mutation SetAccountSuspended($email: String, $accountId: ID, $suspended: Boolean!) {
  result: StreamToolsSetAccountSuspended(email: $email, accountId: $accountId, suspended: $suspended) {
    accountId
    suspended
    suspendedAt
    previouslySuspended
  }
}
